/**
 * Sales Command Center — Redux Slice
 */
import { createSlice } from '@reduxjs/toolkit';

const sccSlice = createSlice({
  name: 'scc',
  initialState: {
    activeCall: null,      // Current active call state
    callTimer: 0,          // Seconds elapsed in active call
    selectedLead: null,    // Currently selected lead for detail view
    queueFilters: { temperature: null, status: null, search: '' },
    demoMode: true,
    dispositionModalOpen: false,
    callingInterfaceOpen: false,
  },
  reducers: {
    setActiveCall: (state, action) => { state.activeCall = action.payload; },
    clearActiveCall: (state) => { state.activeCall = null; state.callTimer = 0; },
    incrementTimer: (state) => { state.callTimer += 1; },
    setSelectedLead: (state, action) => { state.selectedLead = action.payload; },
    setQueueFilters: (state, action) => { state.queueFilters = { ...state.queueFilters, ...action.payload }; },
    setDemoMode: (state, action) => { state.demoMode = action.payload; },
    openDispositionModal: (state) => { state.dispositionModalOpen = true; },
    closeDispositionModal: (state) => { state.dispositionModalOpen = false; },
    openCallingInterface: (state) => { state.callingInterfaceOpen = true; },
    closeCallingInterface: (state) => { state.callingInterfaceOpen = false; },
  },
});

export const {
  setActiveCall, clearActiveCall, incrementTimer, setSelectedLead,
  setQueueFilters, setDemoMode, openDispositionModal, closeDispositionModal,
  openCallingInterface, closeCallingInterface,
} = sccSlice.actions;

export default sccSlice.reducer;
